export default "__VITE_ASSET__b3d099df__"